export const PULSE_NAMES = {
  SECTION_ITEM: 'section-item',
  UPLOAD_AREA: 'upload-area',
  GEN_AI_LOGO: 'gen-ai-logo',
  GENERATE: 'generate',
  REMOVE_BUTTON: 'remove-button',
  VIEW_MORE: 'view-more',
  LOGIN_BUTTON: 'login-button',
  SIGN_OUT_BUTTON: 'sign-out-button',
  CREDITS_BADGE: 'credits-badge',
  UPGRADE_BUTTON: 'upgrade-button',
  USER_MENU: 'user-menu',
  PRICING_BUTTON: 'pricing-button',
  PROJECTS_BUTTON: 'projects-button',
  PROJECTS_ITEM: 'projects-item',
  CREDITS_ROW: 'credits-row',
  HERO_CAROUSEL: 'hero-carousel',
  HERO_CAROUSEL_CARD: 'hero-carousel-card',
  HERO_CAROUSEL_ARROW: 'hero-carousel-arrow',
  PROMO_BANNER: 'promo-banner',
  PROMO_BANNER_CTA: 'promo-banner-cta',
  TRENDING_SECTION: 'trending-section',
  TRENDING_SEE_ALL: 'trending-see-all',
  FILTER_BAR: 'filter-bar',
  FILTER_SEGMENT: 'filter-segment',
  FILTER_CHIP: 'filter-chip',
  BROWSE_PANEL: 'browse-panel',
  BROWSE_SEARCH: 'browse-search',
  SEASONAL_CONTENT: 'seasonal-content',
  APP_BANNER_OPEN: 'app-banner-open',
  APP_BANNER_CLOSE: 'app-banner-close',
};
